<template>
  <div>
    <component :is="layout" />
    <router-view/>
    <loading v-if="$root.loading"/>
    <component :is="footer" />
    <!-- {{ version }} !-->
  </div>
</template>
<script>

const default_layout = 'navigation'
const default_footer = 'purealm-footer'

export default {
  name: 'App',
  components: {
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout);
    },
    footer() {
      return (this.$route.meta.footer || default_footer);
    }
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    }
  },
  props: {
  },
  mounted() {
  },
  methods: {
  }
}
</script>
